<template>
  <div>
    <title-bar title="设备序列号生成">
      <el-button type="primary" @click="edit()">添加</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="年月">
          <el-date-picker type="month" v-model="queryForm.yearMonth" value-format="yyyyMM" @change="query"></el-date-picker>
        </el-form-item>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="month" label="年月" align="center" width="100"></el-table-column>
        <el-table-column prop="serialCount" label="设备数量" align="center" width="120"></el-table-column>
        <el-table-column prop="startNum" label="开始编号" align="center" min-width="120"></el-table-column>
        <el-table-column prop="endNum" label="结束编号" align="center" min-width="120"></el-table-column>
        <el-table-column prop="userName" label="操作人" align="center" min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="130"></el-table-column>
        <el-table-column prop="action" label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)" v-if="!row.created">
              编辑
            </el-button>
            <el-button type="text" @click="createDevice(row)" v-if="!row.created">
              生成设备
            </el-button>
            <el-button type="text" @click="del(row)" v-if="!row.created">
              删除
            </el-button>
            <el-button type="text" @click="printSerial(row)" v-if="row.created">
              打印
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <device-serial-edit title="设备序列号编辑"
                        :visible.sync="editing"
                        v-if="editing"
                        :record="record"
                        @close="editing=false"
                        @save="onSave"></device-serial-edit>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import DeviceSerialEdit from "@/components/device-serial/DeviceSerialEdit";
export default {
  name: 'DeviceSerialNumber',
  components: {DeviceSerialEdit, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        yearMonth: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: [],
      record: null
    }
  },
  created() {
    //重置缓存
    this.queryForm = this.getComponentCache() || this.queryForm;
    this.clearComponentCache();
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-serials/v2/getDeviceSerialsList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    edit(row) {
      let y = new Date().getFullYear();
      let m = new Date().getMonth()+1;
      this.record = row || {
        month: y+(m<10?"0"+m:m)+"",
        serialCount: 1
      }
      console.log(this.record);
      this.editing = true;
    },
    onSave(){
      this.editing = false;
      this.query();
    },
    createDevice(row){
      this.loading = true;
      this.postForm("/device-serials/saveDevice", row, true).then(dr=>{
        this.query();
      }).finally(()=>{
        this.loading = false;
      });
    },
    printSerial(){
      //TODO:
    },
    del(row) {
      this.$confirm("确定要删除这些设备序列号吗？","系统提示").then(()=>{
        this.loading = true;
        this.postForm("/device-serials/deleteSerials", {
          id: row.id
        },true).then(()=>{
          this.query();
        }).finally(()=>{
          this.loading = false;
        })
      });
    }
  }
}
</script>

<style scoped>

</style>